import { atom } from 'jotai';

import { type ConnectionAddressObject } from '@origin-digital/address-lookup';

export const selectedAddressAtom = atom<ConnectionAddressObject | undefined>(undefined);

export const unconfirmedAddressAtom = atom<ConnectionAddressObject | undefined>(undefined);

// List of addresses returned from Origin Addresses API
export const originAddressesAtom = atom<ConnectionAddressObject[]>([]);
